export default __webpack_public_path__ + "static/media/nft-6.0a5b6472.png";